import AccountSetupPage from './AccountSetupPage';

export default AccountSetupPage;
